import { Playground, Props } from 'docz';
import Component from 'react-component-component';
import { Badge } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Component,
  Badge,
  React
};